import {v4 as uuidv4} from 'uuid';
import * as NetteAjax from './NetteAjax';
import * as Url from './Url';

document.addEventListener("DOMContentLoaded", function() {
    initialize();
});

type state = {
    alert: HTMLElement,
    acceptBtn: HTMLButtonElement,
    rejectBtn: HTMLButtonElement,
    setByInputsBtn: HTMLButtonElement,
    inputs: NodeListOf<HTMLInputElement>,
};

type stateSelected = state & {
    consents: {},
    expirationDays: number,
};

type statePersisted = stateSelected & {
    cookieId: string,
};

function initialize() {

    let cookieAlert = document.querySelector('[data-spinao-cookie-consent="alert"]') as HTMLElement | null;

    if(cookieAlert) {
        const state : state = {
            alert: cookieAlert,
            acceptBtn: cookieAlert.querySelector('[data-spinao-cookie-consent="accept"]') as HTMLButtonElement,
            rejectBtn: cookieAlert.querySelector('[data-spinao-cookie-consent="reject"]') as HTMLButtonElement,
            setByInputsBtn: cookieAlert.querySelector('[data-spinao-cookie-consent="setByInputs"]') as HTMLButtonElement,
            inputs: cookieAlert.querySelectorAll('[data-spinao-cookie-consent="inputs"] [type="checkbox"]') as NodeListOf<HTMLInputElement>,
        };

        if(state.acceptBtn) {
            state.acceptBtn.addEventListener('click', function(e: Event) {
                e.preventDefault();
                hideAlert(persist(accept(state)));
            });
        }

        if(state.rejectBtn) {
            state.rejectBtn.addEventListener('click', function(e: Event) {
                e.preventDefault();
                hideAlert(persist(reject(state)));
            });
        }

        if(state.setByInputsBtn) {
            state.setByInputsBtn.addEventListener('click', function(e: Event) {
                e.preventDefault();
                hideAlert(persist(setByInputs(state)));
            });
        }
    }
}

function accept(state: state): stateSelected
{
    let consents = {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        security_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
    };

    return {...state, ...{consents: consents, expirationDays: 180}};
}

function reject(state: state): stateSelected
{
    let consents = {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        security_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'denied',
    };

    return {...state, ...{consents: consents, expirationDays: 14}};
}

function setByInputs(state: state): stateSelected
{
    let consents = {
        security_storage: 'granted'
    };

    state.inputs.forEach(function(element) {
        let name = element.getAttribute('name');

        if(name) {
            consents[name] = name === 'functionality_storage' || element.checked ? 'granted' : 'denied';
            if (name === 'ad_storage') {
                consents['ad_user_data'] = element.checked ? 'granted' : 'denied';
                consents['ad_personalization'] = element.checked ? 'granted' : 'denied';
            }
        }
    });

    return {...state, ...{consents: consents, expirationDays: 31}};
}

function persist(state: stateSelected): statePersisted
{
    let uuid = uuidv4();
    let date = new Date();
    date.setTime(date.getTime() + (state.expirationDays*24*60*60*1000));

    document.cookie = 'cookie-consent=' + uuid + '; path=/; expires=' + date.toUTCString();

    let form = state.alert.querySelector('form') as HTMLFormElement | null;

    if(form) {
        let action = form.getAttribute('action');

        if(action) {
            NetteAjax.sendRequest(
                {
                    url: Url.addParameters(action, [['consentId', uuid], ['consents', JSON.stringify(state.consents)]])
                }
            );
        }
    }

    window.dataLayer.push({
        'event': 'UpdateConsent',
        'consent': state.consents,
    });

    return {...state, ...{cookieId: uuid}};
}

function hideAlert(state: statePersisted): void
{
    state.alert.style.display = 'none';
}
